export const _comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/
